import { useState, useEffect } from 'react'
import { X } from 'lucide-react'

export function useRegisterSW() {
  const [registration, setRegistration] = useState(null)
  const [updateReady, setUpdateReady] = useState(false)

  useEffect(() => {
    if ('serviceWorker' in navigator && import.meta.env.PROD) {
      navigator.serviceWorker.ready.then((reg) => {
        setRegistration(reg)
        reg.addEventListener('updatefound', () => {
          const newWorker = reg.installing
          newWorker?.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              setUpdateReady(true)
            }
          })
        })
      })
    }
  }, [])

  const update = () => {
    registration?.waiting?.postMessage({ type: 'SKIP_WAITING' })
    setUpdateReady(false)
    window.location.reload()
  }

  return { updateReady, update }
}

export function useInstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [installable, setInstallable] = useState(false)
  const [installed, setInstalled] = useState(false)

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setInstallable(true)
    }
    window.addEventListener('beforeinstallprompt', handler)

    if (window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone) {
      setInstalled(true)
    }

    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const install = async () => {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') {
      setInstallable(false)
      setInstalled(true)
    }
  }

  return { installable, installed, install }
}

export function InstallBanner() {
  const { installable, installed, install } = useInstallPrompt()
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    const stored = localStorage.getItem('pwa_install_dismissed')
    if (stored) setDismissed(true)
  }, [])

  const handleDismiss = () => {
    setDismissed(true)
    localStorage.setItem('pwa_install_dismissed', '1')
  }

  if (!installable || installed || dismissed) return null

  return (
    <div className="install-banner">
      <div className="install-banner-content">
        <span>Install RadianTech Fitness for a better experience</span>
        <div className="install-banner-actions">
          <button onClick={install} className="btn btn-primary btn-sm">Install</button>
          <button onClick={handleDismiss} className="btn btn-outline btn-sm" aria-label="Dismiss">
            <X size={18} />
          </button>
        </div>
      </div>
    </div>
  )
}
